(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ixma-garan-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ixma-garan-preview')) {
    customElements.define('ixma-garan-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.drawer = this.querySelector('x-drawer');
        const drawerTemplate = this.querySelector('template[data-ixma-garan-drawer]');
        if (!this.drawer && drawerTemplate) {
          this.append(drawerTemplate.content.cloneNode(true));
          this.drawer = this.querySelector('x-drawer');
        }
        this.variantLabels = [...this.querySelectorAll('[data-ixma-garan-variant]')];
        this.form = this.closest('form');
        this.form?.addEventListener('variant:change', event => {
          this.updateVariant(String(event.detail?.variant?.id || ''), String(event.detail?.variant?.sku || ''));
        }, { signal: this.controller.signal });
        this.updateVariant(this.dataset.variantId, this.dataset.variantSku);
      }

      updateVariant(variantId, variantSku) {
        const variants = {
          '52650793402714': { label: this.dataset.whiteLabel, sku: 'E10068wh' },
          '52650793435482': { label: this.dataset.blackLabel, sku: 'E10068bk' }
        };
        const variant = variants[variantId];
        const label = variant?.sku === variantSku ? variant.label : null;
        this.hidden = !label;
        if (!label) {
          if (typeof this.drawer?.hide === 'function') this.drawer.hide();
          return;
        }
        this.variantLabels.forEach(element => { element.textContent = label; });
        this.dataset.variantId = variantId;
        this.dataset.variantSku = variantSku;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.drawer?.parentElement === document.body) this.drawer.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ixma-guarantee-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('[data-ixma-guarantee-text]') : null;
    if (!link) return;
    const heading = document.getElementById('ixma-guarantee-transcript-title');
    if (!heading) return;
    event.preventDefault();
    heading.scrollIntoView({ block: 'start', behavior: 'instant' });
    heading.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ixma-manufacturer-warranty"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ixma-manufacturer-warranty')) {
    customElements.define('ixma-manufacturer-warranty', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        try {
          this.variants = JSON.parse(this.querySelector('[data-warranty-variants]')?.content.textContent || '{}');
        } catch {
          this.hidden = true;
          return;
        }
        this.variantLabel = this.querySelector('[data-warranty-variant]');
        this.form = this.closest('form') || document.getElementById(this.dataset.formId);
        this.form?.addEventListener('variant:change', event => {
          const variant = event.detail?.variant;
          this.updateVariant(String(variant?.id || ''), String(variant?.sku || ''));
        }, { signal: this.controller.signal });
        this.updateVariant(this.dataset.variantId, this.dataset.variantSku);
      }

      updateVariant(variantId, sku) {
        const variant = this.variants?.[variantId];
        const allowed = Boolean(variant && variant.sku === sku);
        this.hidden = !allowed;
        if (!allowed) return;
        if (this.variantLabel) this.variantLabel.textContent = variant.label;
        this.dataset.variantId = variantId;
        this.dataset.variantSku = sku;
        this.dataset.manufacturerModel = variant.model;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
